//@flow
import * as React from 'react';
import {Link} from "react-router-dom";
import {agentViewPageIds} from "../../../../../../tests/testIds";
import text from "../../../../../../services/localization/text";
import Can from "../../../../../../services/permissions/Can";
import {agentPathEdit, mainDataSuffix, orgPath} from "../../../../../../services/urlStrings/urlStrings";
import type {agentId, organizationId} from "../../../../../../services/flowTypes/dataFlowTypes";
import {permissionsStrValues} from "../../../../../../configData/permissionsStrValues";
import BtnNewItem from "../../../../../../components/simple/Buttons/BtnNewItem/BtnNewItem";

type Props = {
  organizationId: organizationId,
  agentId: agentId
};

const AgentMainDataEditButton = (props: Props) => {
  const linkToEdit = orgPath(props.organizationId) + agentPathEdit(props.agentId) + mainDataSuffix;
  return (
    <Can do={'usePermission'} on={permissionsStrValues.agent.update}>
      <Link className={"button-wrapper-link"} to={linkToEdit}>
        <BtnNewItem id={agentViewPageIds.buttonEdit}>{text.btnEdit}</BtnNewItem>
      </Link>
    </Can>
  );
};

export default AgentMainDataEditButton;    